
import { Component, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import  *  as  helpData  from  '../../../data/help/compliance_summary.json';

//Model
import { ChartData } from '../../../model/compliance.model';

//Service
import { ComplianceService } from './../../../services/compliance.service';
import { DataService } from '../../../services/data.service';


@Component({
    selector: 'app-summary',
    templateUrl: './summary.component.html',
    styleUrls: ['./summary.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [ComplianceService]
})
export class SummaryComponent {


    public single: any[];
    public driver: any[];
    public vehicle: any[];
    public multi: any[];
    public showXAxis = true;
    public showYAxis = true;


    public showXAxisLabel = true;

    public showYAxisLabel = true;

    public xAxisLabel: string;
    public yAxisLabel: string;


    public showLegend = true;
    public gradient = true;
    public colorScheme = {
        domain: ['#ff0000','#006400']
    };
    public colorSchemes = {
        domain: ['#ff0000', '#f27e30', '#ffff00', '#006400']
    };
    public showLabels = true;
    public explodeSlices = false;
    public doughnut = false;

    driverChartYearly: ChartData[];
    driverChartQuarterly: ChartData[];
    driverChartMonthly: ChartData[];
    driverChartWeekly: ChartData[];
    driverChartDaily: ChartData[];

    vehicleChartYearly: ChartData[];
    vehicleChartQuarterly: ChartData[];
    vehicleChartMonthly: ChartData[];
    vehicleChartWeekly: ChartData[];
    vehicleChartDaily: ChartData[];


    driverTests: any;
    vehicleTests: any;
    fleetMaintenance: any;
    regoRegistrations: any;
    driverIncidents: any;
    driverLicences: any;

    public drivers: number;
    public drivers1: number;
    public drivers2: number;
    public drivers3: number;
    public drivers4: number;
    public drivers5: number;
    public drivers6: number;
    public drivers7: any;
    public drivers8: any;
    public drivers9: any;
    public result: any;
    public vehicles: any;
    public vehicles1: any;
    public vehicles2: any;
    public vehicles3: any;
    public vehicles4: any;
    public vehicles5: any;
    public vehicles6: any;
    public vehicles7: any;
    public vehicles8: any;
    public vehicles9: any;
    public maintenance: number;
    public maintenance1: number;
    public maintenance2: number;
    public maintenance3: number;
    public maintenance4: number;
    public incidents: number;
    public incidents1: number;
    public incidents2: number;
    public incidents3: number;
    public incidents4: number;
    public registrations: number;
    public registrations1: number;
    public registrations2: number;
    public registrations3: number;
    public licences1:number;
    public licences2: number;
    public licences3: number;
    myDropDown: string;

    currentDriverChartData: ChartData[];
    currentVehicleChartData: ChartData[];
    help: any;
    loadingIndicator: boolean = true;

    constructor(private http: HttpClient, private complianceService: ComplianceService, private data: DataService){
        this.getOverview(); {
            this.single = [{
                name: 'Fleet Maintenance',
                value: 40000
            },
            {
                name: 'Driver Incidents',
                value: 40000
            }];
            
            this.vehicle = [{
                name: 'Failed',
                value: 6
            },
            {
                name: 'Passed',
                value: 20
            }];
        }
    }

    public onSelect(event) {console.log(event);}


    public getOverview() {
        this.complianceService.getOverview().subscribe(data => {
            this.result = data;
            this.driverTests = data['driver_tests'];
            this.vehicleTests = data['vehicle_tests'];
            this.fleetMaintenance = data['maintenance'];
            this.driverIncidents = data['incidents']
            this.regoRegistrations = data['registrations'];
            this.driverLicences = data['licences'];
            
            this.maintenance = this.result['maintenance']['fleet_count']
            this.maintenance1 = this.result['maintenance']["ok"]
            this.maintenance2 = this.result['maintenance']['low']
            this.maintenance3 = this.result['maintenance']['moderate']
            this.maintenance4 = this.result['maintenance']['serious']
            this.incidents1 = this.result['incidents']['ok']
            this.incidents2 = this.result['incidents']['low']
            this.incidents3 = this.result['incidents']['moderate']
            this.incidents4 = this.result['incidents']['serious']
            this.registrations1 = this.result['registrations']['current'];
            this.registrations2 = this.result['registrations']['expiring'];
            this.registrations3 = this.result['registrations']['expired'];
            this.licences1 = this.result['licences']['current']
            this.licences3 = this.result['licences']['expired']
            this.licences2 = this.result['licences']['expiring']

            console.log('DRIVER TESTS', this.driverTests);
            console.log('VEHICLE TESTS', this.vehicleTests);

            this.myDropDown = 'today';

            if (this.driverTests && this.vehicleTests) {
                this.initChartData();
                console.log('the source', this.driverChartQuarterly);
                this.currentDriverChartData = this.driverChartDaily;
                this.currentVehicleChartData = this.vehicleChartDaily;
            }

        });
    }

    ngOnInit() {
        this.data.currentHelp.subscribe(help => this.help = help);
        setTimeout(() => { this.loadingIndicator = false; }, 1000);
    }

    ngAfterViewInit() {
		setTimeout(() => { this.data.changeHelp(helpData["default"])});
	}


    initChartData(){
        this.driverChartYearly = [];
        this.driverChartQuarterly = [];
        this.driverChartMonthly = [];
        this.driverChartWeekly = [];
        this.driverChartDaily = [];

        this.vehicleChartYearly = [];
        this.vehicleChartQuarterly = [];
        this.vehicleChartMonthly = [];
        this.vehicleChartWeekly = [];
        this.vehicleChartDaily = [];

        
        const yearlyData = {
            name: "Failed",
            value: this.driverTests.yearly.failed
        }

        const yearlyData2 = {
            name: "Passed",
            value: this.driverTests.yearly.passed
        }

        const quarterlyData = {
            name: "Failed",
            value: this.driverTests.quarterly.failed
        }

        const quarterlyData2 = {
            name: "Passed",
            value: this.driverTests.quarterly.passed
        }

        const monthlyData = {
            name: "Failed",
            value: this.driverTests.monthly.failed
        }

        const monthlyData2 = {
            name: "Passed",
            value: this.driverTests.monthly.passed
        }

        const weeklyData = {
            name: "Failed",
            value: this.driverTests.weekly.failed
        }

        const weeklyData2 = {
            name: "Passed",
            value: this.driverTests.weekly.passed
        }

        const dailyData = {
            name: "Failed",
            value: this.driverTests.daily.failed
        }

        const dailyData2 = {
            name: "Passed",
            value: this.driverTests.daily.passed
        }

        const vehicleYearlyData = {
            name: "Failed",
            value: this.vehicleTests.yearly.failed
        }

        const vehicleYearlyData2 = {
            name: "Passed",
            value: this.vehicleTests.yearly.passed
        }

        const vehicleQuarterlyData = {
            name: "Failed",
            value: this.vehicleTests.quarterly.failed
        }

        const vehicleQuarterlyData2 = {
            name: "Passed",
            value: this.vehicleTests.quarterly.passed
        }

        const vehicleMonthlyData = {
            name: "Failed",
            value: this.vehicleTests.monthly.failed
        }

        const vehicleMonthlyData2 = {
            name: "Passed",
            value: this.vehicleTests.monthly.passed
        }

        const vehicleWeeklyData = {
            name: "Failed",
            value: this.vehicleTests.monthly.failed
        }

        const vehicleWeeklyData2 = {
            name: "Passed",
            value: this.vehicleTests.monthly.passed
        }

        const vehicleDailyData = {
            name: "Failed",
            value: this.vehicleTests.daily.failed
        }

        const vehicleDailyData2 = {
            name: "Passed",
            value: this.vehicleTests.daily.passed
        }


        
        this.driverChartYearly.push(yearlyData);
        this.driverChartYearly.push(yearlyData2);

        this.driverChartQuarterly.push(quarterlyData);
        this.driverChartQuarterly.push(quarterlyData2);

        this.driverChartMonthly.push(monthlyData);
        this.driverChartMonthly.push(monthlyData2);

        this.driverChartWeekly.push(weeklyData);
        this.driverChartWeekly.push(weeklyData2);

        this.driverChartDaily.push(dailyData);
        this.driverChartDaily.push(dailyData2);



        this.vehicleChartYearly.push(vehicleYearlyData);
        this.vehicleChartYearly.push(vehicleYearlyData2);
        this.vehicleChartQuarterly.push(vehicleQuarterlyData);
        this.vehicleChartQuarterly.push(vehicleQuarterlyData2);
        this.vehicleChartMonthly.push(vehicleMonthlyData);
        this.vehicleChartMonthly.push(vehicleMonthlyData2);
        this.vehicleChartWeekly.push(vehicleWeeklyData);
        this.vehicleChartWeekly.push(vehicleWeeklyData2);
        this.vehicleChartDaily.push(vehicleDailyData);
        this.vehicleChartDaily.push(vehicleDailyData2);

   

        console.log('yearly', this.driverChartYearly);
        console.log('quarterly', this.driverChartQuarterly);
        console.log('monthly', this.driverChartMonthly);
        console.log('weekly', this.driverChartWeekly);
        console.log('daily', this.driverChartDaily);


        this.multi = [{
            name: 'Fleet Maintenance',
            series: [{
                name: 'Serious',
                value: this.maintenance4
            },
            {
                name: 'Moderate',
                value: this.maintenance3
            },
            {
                name: 'Low',
                value: this.maintenance2
            },
            {
                name: 'OK',
                value: this.maintenance1
            }]
        },
        {
            name: 'Driver Incidents',
            series: [{
                name: 'Serious',
                value: this.incidents4
            },
            {
                name: 'Moderate',
                value: this.incidents3
            },
            {
                name: 'Low',
                value: this.incidents2
            },
            {
                name: 'OK',
                value: this.incidents1
            }]
        },
        {
            name: 'Registrations',
            series: [{
                name: 'Serious',
                value: this.registrations3
            },
            {
                name: 'Moderate',
                value: this.registrations2
            },
            {
                name: 'Low',
                value: 0
            },
            {
                name: 'OK',
                value: this.registrations1
            }]
        },
        {
            name: 'Driver Licences',
            series: [{
                name: 'Serious',
                value: this.licences3
            },
            {
                name: 'Moderate',
                value: this.licences2
            },
            {
                name: 'Low',
                value: 0
            },
            {
                name: 'OK',
                value: this.licences1
            }]
        }];
    }

   
    onChangeofOptions(selected) {
        console.log('changing to', selected);
        if (selected == 'yearly') {
            this.currentDriverChartData = this.driverChartYearly;
            this.currentVehicleChartData = this.vehicleChartYearly;
        }
        else
        if (selected == 'quarterly') {
            this.currentDriverChartData = this.driverChartQuarterly;
            this.currentVehicleChartData = this.vehicleChartQuarterly;
        }
        else 
        if (selected == 'monthly') {
            this.currentDriverChartData = this.driverChartMonthly;
            this.currentVehicleChartData = this.vehicleChartMonthly;
        }
        else
        if (selected == 'weekly') {
            this.currentDriverChartData = this.driverChartWeekly;
            this.currentVehicleChartData = this.vehicleChartWeekly;
        }
        else
        if (selected == 'today') {
            this.currentDriverChartData = this.driverChartDaily;
            this.currentVehicleChartData = this.vehicleChartDaily;
        }

        this.currentDriverChartData = [...this.currentDriverChartData];
        this.currentVehicleChartData = [...this.currentVehicleChartData];
    }


    isDriverTestsEmpty() {
        if (!this.currentDriverChartData )
            return true;
        if (this.currentDriverChartData[0].value == 0 && this.currentDriverChartData[1].value == 0)
            return true;
        else return false;
    }

    isVehicleTestsEmpty() {
        if (!this.currentVehicleChartData)
            return true;
        if (this.currentVehicleChartData[0].value == 0 && this.currentVehicleChartData[1].value == 0)
            return true;
        else return false;
    }
}
